import * as React from "react";
import Typography from "../Typography";
import { FormattedDate, FormattedMessage } from "react-intl";
import * as styles from "./styles";
import { colors } from "../../styles/styles";
import { HooplaEventPurchase } from "../../types";
import InfoBubble from "../InfoBubble";
import Button, { OutsideLinkButton } from "../Button";
import { ticketsDownloaded } from "../../gtm";
import { getDomain } from "helpers/getDomain";

interface IPurchaseRowProps {
  purchases: HooplaEventPurchase[];
  eventId: number;
}

const downloadTickets = (purchaseId: string, hash: string) => {
  window.location.href = `/api/v4.0/pdf/purchases/${purchaseId}/?h=${hash}`;
  ticketsDownloaded(parseInt(purchaseId, 10));
};

const getPurchaseActions = (eventId: number, purchase: HooplaEventPurchase) => {
  if (purchase.numberOfTickets < 1) {
    return null;
  } else if (purchase.numberOfTickets === purchase.numberOfRevokedTickets) {
    return (
      <InfoBubble
        content={
          <div className={styles.revoked}>
            <FormattedMessage id="components.TicketList.revoked" />
          </div>
        }
        style={{ borderColor: colors.red_00, opacity: 0.65 }}
      />
    );
  }
  return (
    <React.Fragment>
      <Button
        variant="outlined"
        onClick={() => downloadTickets(String(purchase.purchase.purchaseId), purchase.refCodeHash)}
      >
        <FormattedMessage id="components.TicketList.download" />
      </Button>
      <OutsideLinkButton
        variant="lightblue"
        to={`https://m.${getDomain()}/p/${purchase.refCode}.${purchase.refCodeHash}`}
      >
        <FormattedMessage id="components.TicketList.show" />
      </OutsideLinkButton>
    </React.Fragment>
  );
};

const PurchaseTable: React.FC<IPurchaseRowProps> = ({ purchases, eventId }) => (
  <tbody>
    {purchases.map((purchase) => (
      <tr key={purchase.purchase.purchaseId}>
        <td />
        <td>
          <Typography>
            <FormattedDate
              value={purchase.purchase.finalized}
              day="numeric"
              month="long"
              year="numeric"
            />
          </Typography>
        </td>
        <td>
          <Typography>{purchase.purchase.purchaseId}</Typography>
        </td>
        <td>
          <Typography>
            <FormattedMessage
              id="components.TicketList.numTickets"
              values={{
                tickets: purchase.numberOfTickets,
                revoked:
                  purchase.numberOfTickets - purchase.numberOfRevokedTickets > 0
                    ? purchase.numberOfRevokedTickets
                    : 0,
              }}
            />
          </Typography>
        </td>
        <td>
          <div className={styles.purchaseActions}>{getPurchaseActions(eventId, purchase)}</div>
        </td>
      </tr>
    ))}
  </tbody>
);

export default PurchaseTable;
